import IntegrationTable from "@/components/shared/IntegrationTable/IntegrationTable";
import MundMemberkit from "../icons/MundMemberkit";
import MemberkitIcon from "../icons/Memberkit";
import { integrationFieldPresets } from "@/components/shared/IntegrationTable/integrationFieldPresets";

export default function Memberkit() {
  return (
    <IntegrationTable
      integrationKey="memberkit"
      title="Memberkit"
      main_icon={<MundMemberkit />}
      icon={<MemberkitIcon />}
      fields={[
        integrationFieldPresets.access_token,
        integrationFieldPresets.metadata,
        integrationFieldPresets.status,
      ]}
      fixedValues={
        {
          payment_methods: ['credit_card', 'pix', 'bank_slip'],
          active_statuses: ['paid']
        }
      }
    />
  );
}
